import { render } from "./Navbar.vue?vue&type=template&id=52505a02&scoped=true"
const script = {}

import "./Navbar.vue?vue&type=style&index=0&id=52505a02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52505a02"]])

export default __exports__